/*****************************************************************
 *  Viewport Events
 * ***************************************************************/

export const VIEWPORT_MODE = "VIEWPORT_MODE"
export const MAINVIEWER_LAYER = "MAINVIEWER_LAYER"
export const COMPARATIVEVIEWERLEFT_LAYER = "COMPARATIVEVIEWERLEFT_LAYER"
export const COMPARATIVEVIEWERRIGHT_LAYER = "COMPARATIVEVIEWERRIGHT_LAYER"
export const MAINCAMERA_POSITION = "MAINCAMERA_POSITION"
export const STRIPPING_VISIBLE = "STRIPPING_VISIBLE"
export const ATTACHMENT_VISIBLE = "ATTACHMENT_VISIBLE"
export const FOOTER_VISIBLE = "FOOTER_VISIBLE"
export const SET_VERSIONS = "SET_VERSIONS"
export const SET_SELECTED_VERSION = "SET_SELECTED_VERSION"
export const SET_SELECTED_COMPARATIVE_VERSION = "SET_SELECTED_COMPARATIVE_VERSION"
export const MODE = "MODE"
export const GRIDLOADED = "GRIDLOADED"
export const SET_MANDI_ADJUST = "SET_MANDI_ADJUST"
export const TOGGLE_MANDI_ADJUST = "TOGGLE_MANDI_ADJUST"
export const SET_MANDI_ADJUST_ACTIVE = "SET_MANDI_ADJUST_ACTIVE"
export const GRID_ACTIVE = "GRID_ACTIVE"
export const SET_VIEWER_TYPE = "SET_VIEWER_TYPE"
export const SET_MODIFICATIONS = "SET_MODIFICATIONS"